import { useState, useEffect } from "react";
import { SurveyCreatorComponent, SurveyCreator } from "survey-creator-react";
import "survey-core/defaultV2.css";
import "survey-creator-core/survey-creator-core.css";
import { Spinner } from "react-bootstrap";

export function SurveyManager({json, saveSurvey, options, onCreatorReady}) {
    const [creator, setCreator] = useState(null);

    useEffect(() => {
        if (!creator) {
            const newCreator = new SurveyCreator(options);
            newCreator.JSON = json;
            
            newCreator.saveSurveyFunc = (saveNo, callback) => {
                console.log("Survey Creator JSON:", {
                    completeJSON: newCreator.JSON,
                    text: newCreator.text,
                    surveyLogic: newCreator.survey.logic,
                    questions: newCreator.survey.getAllQuestions()
                });
                
                saveSurvey(newCreator.JSON);
                callback(saveNo, true);
            };

            if (onCreatorReady) {
                onCreatorReady(newCreator);
            }
            
            setCreator(newCreator);
        }
    }, [options, json, saveSurvey, onCreatorReady]);

    if (!creator) {
        return (
            <div className="text-center p-5">
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Caricamento...</span>
                </Spinner>
            </div>
        );
    }

    return (
        <div className={"surveyContainer"}>
            <SurveyCreatorComponent creator={creator} />
        </div>
    );
}
